// extracted by mini-css-extract-plugin
export var active = "_h0-2";
export var recordingDot = "_h0-1";
export var recordingIndicator = "_h0-0";